import forEach from 'utils/DOM/forEach'

function textContent(selector: StringOrNodeSelector, value) {
  forEach(selector, node => {
    node.textContent = value
  })
}

export default textContent
